/*

Preisanzeige mit Warenkorb-Button

 */

import { Trans } from '@lingui/macro'
import { useEffect, useState } from 'react'
import './BuyBox.css'
import {logDebug} from "./helpers/general";

function BuyBoxB2B ({ selected }) {

    // URL-Parameter für die Kommunikation mit den Shops zusammenbauen:
    const params =
        "&cl=basket" +
        "&am=1" +
        "&persparam[details]=config" +
        // ewch ist die OXID aus ewconfigurations und wird in der Funktion pctobasket berechnet, wenn hier nichts übergeben wird
        "&complete=1" +
        "&lang=" + window.langNum +
        "&conf_bedframe=" + selected.bedframeId +

        "&aid=" + selected.modelId +
        ((selected.frameQuantity > 1) ? "&conf_fastener=" + selected.connectorId : "") +
        "&conf_fabric=" + selected.fabricId +
        "&conf_footset=" + selected.feetId +

        ((selected.backQuantity > 0) ? "&conf_backpiece=" + selected.backId : "") +
        ((selected.backQuantity > 0) ? "&conf_backpiecefabric=" + selected.backFabricId : "") +
        "&conf_backpieceparts=" +
        ((selected.backId === "none") ?
            "none"
            :
            (((selected.frameQuantity === 2) && (selected.backQuantity === 1)) ? "connected" : "separated")
        )
        +

        ((selected.mattressQuantity > 0) ? "&conf_mattress=" + selected.mattressParentId : "") +
        "&conf_mattressparts=" +
        ((selected.mattressQuantity === 0) ?
            "none"
            :
            (((selected.frameQuantity === 2) && (selected.mattressQuantity === 1)) ? "connected" : "separated")
        )
        +

        "&conf_topperparts=" +
        ((selected.topperQuantity === 0) ?
            "none"
            :
            (((selected.frameQuantity === 2) && (selected.topperQuantity === 1)) ? "connected" : "separated")
        )
        +
        ((selected.topperQuantity > 0) ? "&conf_topper=" + selected.topperParentId : "")

    const [configData, setConfigData] = useState({price: ''})
    function updatePrice () {
        // Fragt den aktuellen Preis beim Shop an
        const fetchConfigData = `${window.shopUrl}index.php?fnc=pcconfig&${params}`
        fetch(fetchConfigData,
            { credentials: 'include' }
        )
            .then(res => res.json())
            .then(data => {
                setConfigData(data)
                logDebug('Preis berechnet mit diesen Optionen:')
                logDebug(selected, true)
            }
        )
    }
    useEffect(() => {
        if (selected) {
            updatePrice()
        }
    }, [selected])

    const [amount, setAmount] = useState(1)
    function updateAmount(e) {
        setAmount(e.target.value);
    }

    return (
        <footer className='buyBox'>
            <a className="btn save" href={`${window.shopUrl}index.php?fnc=pctonoticelist${params}`}>
                <i className="fas fa-save"></i> &nbsp;
                <span className="text"><Trans>speichern</Trans></span>
            </a>
            <div className="totalPrice">&euro; {configData ? configData.price : ''}</div>
            <div className="text"><Trans>Gesamtpreis pro Bett exkl. MwSt.</Trans></div>
            <a href={`${window.shopUrl}index.php?amount=${amount}&fnc=pctobasket${params}`}>
                <button className="btn cartBtn btnPrimary"><Trans>In den Warenkorb</Trans></button>
            </a>
            <input type="text" name="amount" className="amount" defaultValue={amount} onChange={e => updateAmount(e)} />
        </footer>
    )

}

export default BuyBoxB2B
